<template>
    <div class="card">
        <Toast />
        <ConfirmDialog/>
        <div class = "button-row">
            <Button label="입력" icon="pi pi-pencil" class="p-button-success mr-2" @click="btnAct('NEW')" />
            <Button label="조회" icon="pi pi-search" class="p-button-success mr-2" @click="btnAct('SEARCH')" />
            <!-- <Divider layout="vertical"/> -->            
            <Button label="저장" icon="pi pi-save" class="mr-2" @click="btnAct('SAVE')" :disabled="!selectedItems || !selectedItems.length" />
            <Button label="삭제" icon="pi pi-trash" class="p-button-danger mr-2" @click="btnAct('DELETE')" :disabled="!selectedItems || !selectedItems.length" />
            <!-- <Divider layout="vertical"/> -->   
            <Button label="엑셀" icon="pi pi-download" class="mr-2" @click="downloadExcel($event)"  />
            <Button label="CSV" icon="pi pi-download" class="mr-2" @click="exportCSV($event)"  />
        </div>
        <Toolbar>
            <template #start>
                <div class="grid">
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="publicId" v-model="searchParams.publicId" :options ="publicCodes" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 11rem"
                                @change="changePublicId" :disabled="disabledCtrPublicId" scrollHeight="20em" :editable="true"/>
                        <label for="publicId">업체소재지</label>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="corpId" v-model="searchParams.corpId" :options ="custCodes" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 11rem"
                        :disabled="isCustUser" scrollHeight="20em" :editable="true"/>
                        <label for="corpId">업체명</label>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="parkTag" v-model="searchParams.parkTag" :options ="parkTag" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 11rem"/>
                        <label for="parkTag">차고지분류</label>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="useYn" v-model="searchParams.useYn" :options ="yns" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 7rem"/>
                        <label for="useYn">사용여부</label>
                    </div>  
                </div> 
            </template>
        </Toolbar>
        <DataTable id="dt" ref="dt" :value="dataList" showGridlines :rowClass="excellrowcheckclass" 
                    :scrollable="true" scrollHeight="79vh" :loading="loading" scrollDirection="both" rowIndexVar="rowIndex"
                    v-model:selection="selectedItems"
                    editMode="cell" @cell-edit-complete="onCellEditComplete" class="editable-cells-table p-datatable-sm"
                    :paginator="true" :rows="15" :rowsPerPageOptions="[15, 20, 30]"
                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                    responsiveLayout="scroll"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    :resizableColumns="true" columnResizeMode="expand" >
                <Column field="rowNo" header="No" style="min-width:3em; max-width:3em" exportFooter=" ">
                    <template #body="{data, field}">
                        <span name="rowNo" v-if="data[field] == '수정'" style="color: blue;">{{data[field]}}</span>
                        <span name="rowNo" v-else-if="data[field] == '신규'" style="color: red;">{{data[field]}}</span>
                        <span name="rowNo" v-else>{{data[field]}}</span> 
                    </template>
                </Column>
                <Column selectionMode="multiple" style="min-width:3em; max-width:3em" :exportable="false" exportFooter=" "></Column>
                <Column field="publicId" header="*업체소재지" :sortable="true" style="min-width:8em; max-width:8em" headerClass="required-field" exportFooter=" ">
                    <template #body="{data}">
                        {{(publicCodes.find(e=>e.code == data.publicId)||{codeNm:""})['codeNm']}}
                    </template>
                    <template #editor="{ data, field }">
                        <Dropdown v-model="data[field]" :options="publicCodes" optionLabel="codeNm" optionValue="code" :editable="true"/>
                    </template>
                </Column>
                <Column field="corpNm" header="*업체명" :sortable="true" style="min-width:10em; max-width:10em" headerClass="required-field" exportFooter=" ">
                    <template #editor="{ data, field }">
                        <Dropdown v-model="data[field]" :options="custCodes" optionLabel="codeNm" optionValue="code" :editable="true"/>
                    </template>
                </Column>
                <Column field="corpId" header="업체ID" style="width:8em" :sortable="true" hidden exportFooter=" "></Column>
                <Column field="parkTag" header="*차고지분류" :sortable="true" style="min-width:8em; max-width:8em" headerClass="required-field" exportFooter=" ">
                    <template #body="{data}">
                        {{(parkTag.find(e=>e.code == data.parkTag)||{codeNm:""})['codeNm']}}
                    </template>
                    <template #editor="{ data, field }">
                        <Dropdown v-model="data[field]" :options="parkTag" optionLabel="codeNm" optionValue="code" :editable="true"/>
                    </template>
                </Column>
                <Column field="parkAddr" header="*주소" style="min-width:40em; max-width:40em" headerClass="required-field" exportFooter=" ">
                    <template #editor="{ data, field }">
                        <InputText v-model="data[field]" style="width:30em"/>
                    </template>
                </Column>
                <Column field="plottage" header="*면적" :sortable="true" style="min-width:10em; max-width:10em" headerClass="required-field" exportFooter=" ">
                    <template #body="{ data, field }">
                        <span style="display: inline-block;width: 95%; text-align: right;">{{ formatToPriceFixed(data[field],1) }}</span>
                    </template>
                    <template #editor="{ data, field }">
                    <InputNumber v-model="data[field]" mode="decimal" :minFractionDigits="0" :maxFractionDigits="1" :min="0" :max="10000" :useGrouping="false" inputStyle="width:8em"/>
                </template>
                </Column>
                <Column field="publicAmt" header="공시지가" :sortable="true" style="min-width:10em; max-width:10em" exportFooter=" ">
                    <template #body="{ data, field }">
                        <span style="display: inline-block;width: 95%; text-align: right;">{{ formatToPrice(data[field]) }}</span>
                    </template>
                    <template #editor="{ data, field }">
                    <InputNumber v-model="data[field]" mode="decimal" :minFractionDigits="0" :maxFractionDigits="0" :min="0" :max="1000000000" :useGrouping="false" inputStyle="width:8em"/>
                </template>
                </Column>
                <Column field="dealAmt" header="거래금액" :sortable="true" style="min-width:10em; max-width:10em" exportFooter=" ">
                    <template #body="{ data, field }">
                        <span style="display: inline-block;width: 95%; text-align: right;">{{ formatToPrice(data[field]) }}</span>
                    </template>
                    <template #editor="{ data, field }">
                    <InputNumber v-model="data[field]" mode="decimal" :minFractionDigits="0" :maxFractionDigits="0" :min="0" :max="1000000000" :useGrouping="false" inputStyle="width:8em"/>
                </template>
                </Column>
                <Column field="useYn" header="사용여부" style="min-width:6em; max-width:6em" exportFooter=" ">
                    <template #body="{data}">
                        {{(yns.find(e=>e.code == data.useYn)||{codeNm:""})['codeNm']}}
                    </template>
                    <template #editor="{ data, field }">
                        <Dropdown v-model="data[field]" :options="yns" optionLabel="codeNm" optionValue="code" :editable="true"/>
                    </template>
                </Column>
                <Column field="remarks" header="비고" exportFooter=" ">
                    <template #editor="{ data, field }">
                        <InputText v-model="data[field]" style="width:8em"/>
                    </template>
                </Column>
        </DataTable>
    </div>
</template>

<script>
import { ref, onMounted, reactive } from 'vue';
import CodeService from '@/service/cm/CodeService';
import CustService from '@/service/ma/CustService';
import MA301040Service from '@/service/ma/MA301040Service';
import JsUtils from '@/utilities/JsUtils';
import { useToast } from 'primevue/usetoast';
import { useConfirm } from "primevue/useconfirm";

export default {
    setup() { 
        onMounted( async () => {
            searchParams.compSeq = 1;
            // 검색조건에 시작일자,종료일자를 표시한다
            let date = new Date();  
            let fromDate = new Date(date.getFullYear(), date.getMonth(), 1);  // 당월 첫째 일자
            searchParams.fromDate = JsUtils.getDateString(fromDate);            
            searchParams.toDate = JsUtils.getDateString(new Date());          // 현재 일자

			codeService.getCodeList({ compSeq:1, upCode:'_public_id'}).then(data=> publicCodes.value = data);  // 관할행정지역 코드
			codeService.getCodeList({ compSeq:1, upCode:'_useoil_tag'}).then(data=> useOilTagCodes.value = data);  // 사용자권한 코드
            codeService.getCodeList({ compSeq:1, upCode:'_area_tag'}).then(data=> cboAreaTags.value = data);  // 영역분류 코드
            codeService.getCodeList({ compSeq:1, upCode:'_run_tag'}).then(data=> cboRunTags.value = data);  // 운행분류 코드
            codeService.getCodeList({ compSeq:1, upCode:'_useoil_tag'}).then(data=> cboOilTags.value = data);  // 사용연료

            // 로그인한 사용자 정보를 얻어온다
            var user = JSON.parse(localStorage.getItem("user"));
            if(user != null && user.username != null) {
                searchParams.compSeq = user.compSeq;    // 법인코드
                searchParams.userGbCd = user.userGbCd; // 사용자구분코드

                if(user.publicId != null && user.publicId != '' && (user.userGbCd == 'cu_user' || user.userGbCd == 'cu_mngr')) {
                        //alert(JSON.stringify(user.publicId));
                        // 업체 목록을 얻어온다
                        await custService.getCodeList(searchParams).then(data => {
                            custCodes.value = data;
                            // 업체 목록에서 사용자가 속한 업체를 선택된 상태로 만든다
                            searchParams.corpId = user.custSeq;
                            if(user.userGbCd != null) {
                                // 업체사용자 또는 업체관리자인 경우, 자신이 속한 업체만 볼수 있게 한다
                                if(user.userGbCd == 'cu_user' || user.userGbCd == 'cu_mngr') {
                                    isCustUser.value = true;  
                                    searchParams.publicId = user.publicId;
                                    disabledCtrPublicId.value = true;
                                }
                                // 시군구담당자인 경우
                                if(user.userGbCd == 'ct_mngr') {
                                    searchParams.publicId = user.publicId;  // 업체소재지
                                }
                            }                                    
                        });
                }
            }

        })
        const isCustUser = ref(false);
		const codeService = new CodeService();
        const custService = new CustService();
        const ma301040Service = new MA301040Service();
        const searchParams = reactive({ctrPublicId:null,corpId:null,areaTag:null,runTag:null,carId:null,fromDate: null, toDate: null});
        const dataList = ref([]);
        const publicCodes = ref([]);
        const custCodes = ref([]);
        const useOilTagCodes = ref([]);
        const cboAreaTags = ref([]);
        const cboRunTags = ref([]);
        const cboCarNos = ref([]);
        const cboOilTags = ref([]);

        const toast = useToast();
        const loading = ref(false);
        const confirm = useConfirm();
        const editingRows = ref([]);
        const selectedItems = ref([]);
        // 사용 여부
        const yns = ref([
            {codeNm: '사용', code: 'Y'},
            {codeNm: '미사용', code: 'N'}
        ]);
        // 차고지 종류
        const parkTag = ref([
            {codeNm: '자가', code: '1'},
            {codeNm: '타가', code: '2'},
            {codeNm: '공영', code: '3'}
        ]);
        // 관할행정 선택여부
        const disabledCtrPublicId = ref(false);
        // 신규 / 수정 컬럼 체크
        const dataListOrigin = ref([]);
        const updateItemsIndex = ref([]);
        const init = () => {
            dataList.value = [];
            dataListOrigin.value = [];
            selectedItems.value = [];
            updateItemsIndex.value = [];
        }
        /**깊은 복사
         * @param {ArrayObject} arrayObject
         * ex) [{...}, {...}, ...]
         */
        const deepCopy = (arrayObject) => {
            return JSON.parse(JSON.stringify(arrayObject));
        }

        // 액셀출력
        const dt = ref(); // 데이터 데이블  ref 

        const btnAct = (_act) =>
        {
            switch(_act)
            {
                case "NEW": {
                        // 검색조건에 관할행정, 업체명이 있는 지 확인한다
                        if(!JsUtils.checkUndefineColumns(searchParams, ["publicId","corpId"])){
                            toast.add({severity:'warn', summary:'필수입력 확인', detail:'업체소제지와 업체명은 필수 입력 하셔야 합니다.', life:2000});
                            return true;
                        }

                        // 현재 목록의 첫번째 row에 신규 행을 추가한다
                        let _ = require('lodash');
                        let _corpNm = _.find(custCodes.value, {'code': searchParams.corpId}).codeNm;

                        dataList.value.unshift({publicId:searchParams.publicId, corpNm:_corpNm, parkTag:searchParams.parkTag, corpId:searchParams.corpId, rowNo:'신규',
                                                plottage:0,publicAmt:0,dealAmt:0,useYn:'Y'});
                    
                        // 목록의 첫번째 row를 편집 상태로 변경한다
                        editingRows.value = [...editingRows.value, dataList.value[0]];                    
                        break;  
                    }
                case "SEARCH":
                        searchMA301040();
                    break;
                 case "SAVE":
                        saveList();
                    break;
                case "DELETE":
                        confirmDeleteList();
                    break; 
                default:
            }
        }

        const searchMA301040 = () => {
            searchParams.fromDate = JsUtils.convertDateToString(searchParams.fromDate);
            searchParams.toDate = JsUtils.convertDateToString(searchParams.toDate);

            loading.value = true;
            init();
            ma301040Service.getList(searchParams).then(data => {                 
                 if (data.length == 0) toast.add({severity:'warn', summary:'조회 결과', detail:'조회 결과가 없습니다.', life:2000});                
               dataList.value = data;
            }).finally(() => {
                loading.value = false;
            });
        };

        const saveList = () => {
            confirm.require({
                message:'선택된 항목(들)을 저장하시겠습니까?',
                header: '저장',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    let _isError = false;
                    // for 루프에서 한번에 빠져나오기 위해 forEach 대신 some 사용 - 첫번째 발생하는 행(Row)의 에러 건에 대해서만 메시지가 표시된다
                    /*
                    selectedItems.value.some(row => {
                        if(!JsUtils.checkUndefineColumns(row, ["corpId","lineId","lineNm","areaTag","ctrPublicId","runTag","strPlace","endPlace","strYmd","useYn"])){
                            toast.add({severity:'warn', summary:'필수입력 확인', detail:'*필수입력이 비워있는 건이 있습니다', life:2000});
                            _isError = true;
                            return true;
                        }
                    });
                    */
                    selectedItems.value.some(row => {
                        let errMsg = JsUtils.checkUndefineColumns2(row, ["publicId","corpNm","parkTag","parkAddr","plottage"]);
                        if(errMsg != null){
                            toast.add({severity:'warn', summary:'필수입력 확인', detail: '*는 필수입력 항목입니다', life:2000});
                            _isError = true;
                            return true;
                        }
                    });

                    // 모든 에러 건(행)에 대한 메시지가 표시된다
                    // selectedItems.value.forEach(row => {
                    //     if(!JsUtils.checkUndefineColumns(row, ["corpId","lineId","lineNm","areaTag","ctrPublicId","runTag","strPlace","endPlace","strYmd0","useYn"])){
                    //         toast.add({severity:'warn', summary:'필수입력 확인', detail:'*필수입력이 비워있는 건이 있습니다', life:2000});
                    //         return;
                    //     }
                    // });

                    // 에러가 있는 경우 종료한다 - 현재 저장 confirm 창을 닫는다
                    if(_isError) return false;

                    //alert('selectedItems.value.length = ' + selectedItems.value.length);
                    //selectedItems.value.endYmd = JsUtils.convertDateToString(selectedItems.value.endYmd);

                    ma301040Service.updateList(selectedItems.value).then(() => {
                        // Datatable에서 선택된 행들을 초기화 한다
                        selectedItems.value = [];
                        searchMA301040();
                        toast.add({severity:'success', summary: '완료', detail: '저장 완료', life: 3000});
                    })
                    .catch(error => {
                        if (error.response) {
                            toast.add({severity:'error', summary: '저장 오류', detail: error.response.data.message});
                        } else if (error.request) {
                            toast.add({severity:'error', summary: '저장 오류', detail: error.request.data});	
                        } else {
                            toast.add({severity:'error', summary: '저장 오류', detail: error.message});	
                        }
                    });
                },
                reject: () => {
                    toast.add({severity:'error', summary:'취소', life: 3000});
                }
            });
        };

        const confirmDeleteList = () =>{
            confirm.require({
                message:'선택된 건(들)을 삭제하시겠습니까?',
                header: '삭제',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    deleteList();                    
                },
                reject: () => {
                    toast.add({severity:'error', summary:'취소', life: 3000});
                }
            })
        }

        const deleteList = () => {
            ma301040Service.deleteList(selectedItems.value)
                .then(() => {                    
                    dataList.value = [];
                    toast.add({severity:'success', summary: '삭제 성공', detail: '삭제 되었습니다', life: 3000});
                    btnAct('SEARCH');
                })
                .catch(error => {
                    toast.add({severity:'error', summary: '삭제 오류', detail: error.message, life: 3000});	
                });
        };

         // 셀 편집 후, Datatable의 해당 행(Row)를 선택된 상태로 만든다
        const onCellEditComplete = (event) => {
            let {data, newValue, field } = event;
            if(data[field] === newValue) return;

            switch (field) {
                case "publicId": // 관할행정구역
                case "corpNm": // 업체명
                case "parkTag": // 차고지분류
                case "parkAddr": // 주소
                case "plottage": // 면적
                case "publicAmt": // 공시지가
                case "dealAmt": // 거래금액
                case "useYn": // 사용여부
                case "remarks": // 비고
                    data[field] = newValue;
                    break;
                default:
                    break;
            }

            // 수정 표시
            //dataList.value[data.rowNo-1].rowNo = '수정';

            // 기존에 추가된 행이 아닌 경우에만 선택된 행 목록에 추가한다
            // 해당 Row를 유일하게 구분할 수 있는 값 사용 예) corpId, lineId
            const _ = require('lodash');
            let _row = _.find(selectedItems.value, function(obj) {
                if (obj.rowNo === data.rowNo) {
                    return true;
                }
            });

            if(_row == null || _row == undefined) {
                selectedItems.value.push(data);
                if(data.rowNo != null && data.rowNo !="신규") {
                    data.rowNo = '수정';
                }
            }

        };

          /**
         * 기존 데이터와 비교하여 다를 경우 No 컬럼에 '수정' 넣기
         * @param {number} rowIdx 
         * @param {object: row data} compareData1 
         * @param {object: row data} compareData2 
         */
        // const changeRowStatus = (rowIdx = -1, compareData1 = {}, compareData2 = {}) => {
        //     if (rowIdx > -1 && dataList.value[rowIdx].rowNo !== '신규') {
        //         let boolCellChanged = true;
        //         Object.keys(compareData1).map(k => {
        //             // null 또는 undefined일 경우 빈값으로 수정하여 비교
        //             if (compareData1[k] == null || compareData1[k] == undefined) compareData1[k] = '';
        //             if (compareData2[k] == null || compareData2[k] == undefined) compareData2[k] = '';
        //             // rowNo 제외하고 비교
        //             if (compareData1[k].toString().trim() != compareData2[k].toString().trim() && k !== 'rowNo') boolCellChanged = false;
        //         })
        //         if (boolCellChanged) {
        //             dataList.value[rowIdx].rowNo = rowIdx + 1;
        //             updateItemsIndex.value.some((v, i) => {
        //                 if (v === rowIdx) {
        //                     updateItemsIndex.value.splice(i, 1);
        //                     // 다시 복구 시 체크 해제
        //                     // selectedItems.value.splice(i, 1)
        //                 }
        //             });
        //         } else {
        //             dataList.value[rowIdx].rowNo = '수정';
        //             if (!updateItemsIndex.value.some((v) => v === rowIdx)) {
        //                 updateItemsIndex.value.push(rowIdx);
        //                 // 수정 시 체크
        //                 // selectedItems.value.push(dataList.value[rowIdx]);
        //             }
        //         }
                
        //         // 행 수정 후 신규 행이 추가 되었을 때 수정했던 행의 index가 변경되면 체크가 정상적으로 제거되지 않는 문제 수정
        //         selectedItems.value = [];
        //         for (let i = 0; i < dataList.value.length; i++) {
        //             if (dataList.value[i].rowNo === '신규' || dataList.value[i].rowNo === '수정') {
        //                 selectedItems.value.push(dataList.value[i]);
        //             }
        //         }
        //     }
        // }

        const changePublicId = () => {
            if(isCustUser.value) {
                return;
            }
            custCodes.value = [];
            // 현재 선택된 업체소재지로 업체 목록을 가져와서 업체명 Dropdown 목록에 표시한다
            custService.getCodeList(searchParams).then(data => {
                custCodes.value = data;
            });
            searchParams.corpId = null;
        }

        const changeCustSeq = () => {
            cboCarNos.value = [];
            // 현재 선택된 업체에 속한 차량번호 목록을 다시 조회하여 Dropdown 목록에 표시한다
            codeService.getTableCodeList({ sqlId:'car_code', compSeq:1, corpId: searchParams.corpId}).then(data=> {
                cboCarNos.value = data;
            });
        }

        // 액셀 다운로드
        const downloadExcel = () => {
            // datatable(즉, users.value)에 있는 모든 항목들을 엑셀 파일로 다운로드 한다 - 컬럼명이 필드(영문)으로 나옴
            //JsUtils.downloadExcel(users.value);

            // table의 html 내용을 그대로 엑셀 파일로 다운로드 한다 - paging 사용 시 해당 한 페이지만 다운로드 됨
            JsUtils.downloadExcel2('dt');  // id='dt'
        }

        // CSV 다운로드
        const exportCSV = () => { 
            dt.value.exportCSV();   // dt는 ref="dt"
        };

        // 천단위마다 콤마(,) 표시를 한다
        const formatToPrice = (value) => {
           var num = Number(value).toFixed(0);
          return `${Number(num).toLocaleString()}`; // "ko-KR"
        }
 
        const formatToPriceFixed = (value, n) => {
            var num = Number(value).toFixed(n);
            return `${Number(num).toLocaleString()}`; // "ko-KR"
        }

        // 날짜 변환
        const convertDateString = (data) => {
            return JsUtils.convertDateString(data);
         }

        return { 
            dt, searchParams, dataList, publicCodes, useOilTagCodes, cboAreaTags, cboRunTags,cboCarNos,cboOilTags, isCustUser, loading, init, deepCopy,
            yns, custCodes, formatToPrice, parkTag, onCellEditComplete, selectedItems, disabledCtrPublicId,
            btnAct, downloadExcel, exportCSV, changePublicId, changeCustSeq, convertDateString , formatToPriceFixed
        }

    }
}
</script>

<style lang="scss" scoped>

.table-header {
    display: flex;
    align-items : center;
    justify-content: space-between;

    @media screen and (max-width: 960px) {
        align-items: start;
	}
}
b{
    font-size: 30px;
}

.user-image {
    width: 50px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.p-dialog .user-image {
    width: 50px;
    margin: 0 auto 2rem auto;
    display: block;
}

.confirmation-content {
    display: flex;
    justify-content: center;
}
@media screen and (max-width: 960px) {
	::v-deep(.p-toolbar) {
		flex-wrap: wrap;
        
		.p-button {
            margin-bottom: 0.25rem;
        }
	}
}
</style>
